import React from "react";
import "./Iss.css";
import Issbg from "../../assets/SunderOffice.png";
import Footer from "../dashBoard/footer/Footer";
import ReUseableHeader from "../ReUseableHeader/ReUseableHeader";

export default function Iss() {
  return (
    <>
      <div className="text-center">
        <ReUseableHeader
          head="Integrated Security System"
          subHead1="About Us"
          subHead2="Integrated Security System"
        ></ReUseableHeader>
      </div>
      <div class="d-flex justify-content-center my-6">
        <h2 class="text-center py-5">Following are the four main components</h2>
      </div>

      <div class="row d-flex justify-content-center mx-4 mb-5">
        <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 py-3 col-md-6 col-sm-12">
          <div class="card border-bottom-0 border-end-0 border-top-3 rounded-0 border-start-0 border-info shadow">
            <ul class="fa-ul">
              <h4 class="fw-bold">Strategy</h4>
              <li className="iconli">Surveillance Cameras</li>
              <li className="iconli">Quick Response Force</li>
              <li className="iconli">Fire & Rescue Service</li>
              <li className="iconli">Medical Service</li>
            </ul>
          </div>
        </div>

        <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 py-3 col-md-6 col-sm-12">
          <div class="shadow card border-bottom-0 border-end-0 border-top-3 rounded-0 border-start-0 border-info">
            <ul class="fa-ul">
              <h4 class="fw-bold">Operation</h4>
              <li className="iconli" class="d-flex">
                Under surveillance 24×7
              </li>
              <li className="iconli">All entrances covered</li>
              <li className="iconli">All exits covered</li>
              <li className="iconli">Main Crossing</li>
              <li className="iconli">Public Gathering</li>
            </ul>
          </div>
        </div>

        <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 py-3 col-md-6 col-sm-12">
          <div class="shadow card border-bottom-0 border-end-0 border-top-3 rounded-0 border-start-0 border-info">
            <ul class="fa-ul">
              <h4 class="fw-bold">ISS Assets</h4>
              <li className="iconli">CCTV Cameras</li>
              <li className="iconli">Control Room</li>
              <li className="iconli">DJI Mavic Pro Drone</li>
              <li className="iconli">
                Full frame DSLR Camera
                <ul class="fa-ul">
                  <li className="iconli" class="d-flex">
                    Dedicated Editing Platform for Videos/ Presentations
                  </li>
                  <li className="iconli">Wireless Sets</li>
                  <li className="iconli">Menpower</li>
                  <li className="iconli" class="d-flex">
                    E-Lane System at Main Gates
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12 col-xxl-3 col-xl-3 col-lg-3 py-3 col-md-6 col-sm-12 mb-5">
          <div class="shadow card border-bottom-0 border-end-0 border-top-3 rounded-0 border-start-0 border-info">
            <ul class="fa-ul">
              <h4 class="fw-bold">Security Plan</h4>
              <li className="iconli" class="d-flex">
                Making Sunder Industrial Estate Safe
              </li>
              <li className="iconli" class="d-flex">
                Automated real-time response to save time and loss
              </li>
              <li className="iconli" class="d-flex">
                Document the moment for subsequent investigation purposes.
              </li>
              <li className="iconli" class="d-flex">
                Quick liaison with rescue, Law enforcement units, in and outside
                SIE.
              </li>
              <li className="iconli" class="d-flex">
                It is designed, developed, and operated by SIE Security and IT.
              </li>
            </ul>
          </div>
        </div>
        <div
          style={{ backgroundImage: `url(${Issbg})` }}
          class="bgImage my-6"
        ></div>
      </div>
      <Footer />
    </>
  );
}
